import { Col, Collapse, Form, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons, FloatingFormItem } from '@/components/_common';
import AreaSelectField from '@/components/_common/AreaSelectField';
import { WorkOrderTypes } from '@/core/domain/NetReport/WorkOrder/WorkOrder.types';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import { isAppPortocar } from '@/index';

export default function ProductiveHoursSoldMoreOptions() {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const typeOptions = [
    {
      value: WorkOrderTypes.budget,
      label: intl({ id: 'productiveHoursSold.option.budget' }),
    },
    {
      value: WorkOrderTypes.warranty,
      label: intl({ id: 'productiveHoursSold.option.warranty' }),
    },
    {
      value: WorkOrderTypes.return,
      label: intl({ id: 'productiveHoursSold.option.return' }),
    },
    {
      value: WorkOrderTypes.courtesy,
      label: intl({
        id: `productiveHoursSold.option.${
          isAppPortocar ? 'insideCourtesy' : 'courtesy'
        }`,
      }),
    },
    {
      value: WorkOrderTypes.totalLoss,
      label: intl({ id: 'productiveHoursSold.option.totalLoss' }),
    },
    {
      value: WorkOrderTypes.revision,
      label: intl({ id: 'productiveHoursSold.option.revision' }),
    },
  ];
  return (
    <Collapse>
      <Collapse.Panel
        key="1"
        header={intl({ id: 'productiveHoursSold.label.moreOptions' })}
      >
        <Form.Item
          name="type"
          label={
            <Title level={5} style={{ margin: '0' }}>
              {intl({ id: 'productiveHoursSold.label.type' })}
            </Title>
          }
        >
          <CheckboxGroupButtons options={typeOptions} />
        </Form.Item>
        <Row gutter={16}>
          <Col span={8}>
            <FloatingFormItem
              name="employeeIds"
              label={intl({ id: 'productiveHoursSold.label.employees' })}
            >
              <EmployeesInfiniteSelectField allowClear />
            </FloatingFormItem>
          </Col>
          <Col span={8}>
            <FloatingFormItem
              name="areaIds"
              label={intl({ id: 'productiveHoursSold.label.area' })}
            >
              <AreaSelectField />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
}
